import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  IconButton,
  Chip,
} from '@mui/material';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import CloseIcon from '@mui/icons-material/Close';

export interface ProductoEnGestion {
  id_producto: string;
  referencia_producto: string;
  descripcion: string;
  unidad_medida: string;
}

interface ModalProductosEnGestionProps {
  open: boolean;
  onClose: () => void;
  productos: ProductoEnGestion[];
  message?: string;
}

export default function ModalProductosEnGestion({
  open,
  onClose,
  productos = [],
  message = 'No se puede hacer un egreso por que existe productos en gestión',
}: ModalProductosEnGestionProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          p: 0.5,
          boxShadow: '0 10px 40px -10px rgba(0,0,0,0.2)',
        },
      }}
    >
      {/* Header */}
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          pb: 1,
          pt: 2,
          px: 3,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 40,
              height: 40,
              borderRadius: '50%',
              bgcolor: 'warning.light',
              color: 'warning.dark',
              opacity: 0.9,
            }}
          >
            <WarningAmberRoundedIcon sx={{ fontSize: 24 }} />
          </Box>
          <Box>
            <Typography variant="h6" component="div" fontWeight={600} lineHeight={1.2}>
              Productos en Gestión Contable
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Validación de inventario
            </Typography>
          </Box>
        </Box>
        <IconButton size="small" onClick={onClose} sx={{ color: 'text.secondary' }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      {/* Content */}
      <DialogContent sx={{ px: 3, py: 2 }}>
        <Box
          sx={{
            p: 1.5,
            mb: 2.5,
            borderRadius: 2,
            bgcolor: 'background.default',
            border: '1px solid',
            borderColor: 'divider',
          }}
        >
          <Typography variant="body2" fontWeight={600}>
            Los siguientes productos estan en proceso de gestión contable y no pueden ser egresados.
          </Typography>
        </Box>

        <TableContainer
          sx={{
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 2,
            maxHeight: 280,
            overflowY: 'auto',
          }}
        >
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 600, bgcolor: 'background.paper', fontSize: '0.75rem', width: '50%' }}>
                  Codigo
                </TableCell>
                <TableCell sx={{ fontWeight: 600, bgcolor: 'background.paper', fontSize: '0.75rem', width: '50%' }}>
                  Descripción
                </TableCell>
                
              </TableRow>
            </TableHead>
            <TableBody>
              {productos.length > 0 ? (
                productos.map((prod, index) => (
                  <TableRow
                    key={prod.id_producto || index}
                    sx={{
                      '&:hover': { bgcolor: 'action.hover' },
                      '&:last-child td, &:last-child th': { border: 0 },
                    }}
                  >
                    <TableCell sx={{ fontSize: '0.8125rem', fontWeight: 600, color: 'text.primary' }}>
                      {prod.referencia_producto}
                    </TableCell>
                    <TableCell sx={{ fontSize: '0.8125rem', color: 'text.secondary' }}>
                      {prod.descripcion}
                    </TableCell>
                    
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={3} align="center" sx={{ py: 3, color: 'text.secondary' }}>
                    No se especificaron productos en el detalle.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>

      {/* Actions */}
      <DialogActions sx={{ px: 3, pb: 2, pt: 1 }}>
        <Button
          onClick={onClose}
          variant="contained"
          color="primary"
          size="medium"
          disableElevation
          sx={{ textTransform: 'none', px: 3, borderRadius: 1.5 }}
        >
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
